export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7872.3bd7ef90.jpg";